import React from 'react';

import { SimplifiedAccountInfoT } from '@consumer-frontend/api';

import { BlocLocNav } from './BlocLocNav';

export type BlocNavSelectionPropsT = {
  accountInfo?: SimplifiedAccountInfoT;
};

export type BlocNavSelectionT = React.FC<BlocNavSelectionPropsT>;

// Add logic here for BLOC vs BINST if that ever becomes a thing
export const BlocNavSelection: BlocNavSelectionT = ({ accountInfo }) => {
  if (accountInfo) {
    return <BlocLocNav
      openLoanNumber={accountInfo.open_loan_number || ''}
      showFeeSaverStatus={accountInfo.show_fee_saver_status}
    />;
  }

  return null;
};
